import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  rightArrow,
  rightArrowHover,
  leaderGraduate
} from '../../../assets/images';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const LeaderItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate(); 
 
  const [news, setNews] = useState([]);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Leaderprojects`,
        { withCredentials: false }
      );
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // Çoklu dil destekli içerik getirme
  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase] || '';
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase] || '';
    return item[fieldBase] || ''; // Default: az
  };

  // URL'den filtre durumunu al
  const filterFromURL = searchParams.get('filter') || 'all';
  const [filter, setFilter] = useState(filterFromURL);

  useEffect(() => {
    setFilter(filterFromURL);
  }, [filterFromURL]);

  const filteredItems = news.filter((item) => {
    if (filter === 'all') return true;
    return String(item.type) === filter;
  });

  const handleFilterChange = (value) => {
    setFilter(value);
    setSearchParams({ filter: value });
  };

  const categories = [
    { value: 'all', label: t('Bütün layihələr') },
    { value: 'Davam edən', label: t('Davam edən') },
    { value: 'Bitmiş', label: t('Bitmiş') },
  ];

  return (
    <div className="pt-[56px] md:pt-[88px] bg-[#F9F9F9] font-secondFont">
      <div className="max-w-containerSm md:max-w-container mx-auto">

    <p className='text-[#1C1C1C] text-[28px] md:text-[36px] font-medium text-center'>{t("Kərimov Ramin")}</p>
  <p className='text-[18px] md:text-[24px] text-[#2a3d63] font-medium mt-6'>{t("Təhsil")}</p>
  <div className='w-full rounded-[16px] px-5 py-4 bg-[#FFF8EA] flex items-center gap-[18px] mt-4'>
 <img src={leaderGraduate} className='w-11 h-11' alt='' />
 <div>
      <p className='text-[#1C1C1C] text-[16px] md:text-[18px] font-medium'>{t("İnşaat Azərbaycan Memarlıq və İnşaat Universiteti, Bakı, Azərbaycan")}</p>
      <p className='text-[#1C1C1C]'>{t("Sənaye və Mülki Tikinti fakultəsi")}</p>
      <p className='text-[14px] text-[#010101]'>1999 – 2003</p>
 </div>
  </div>
      <p className='text-[18px] md:text-[24px] text-[#2a3d63] font-medium mt-6'>{t("Texniki Bacarıqları")}</p>
  <ul className="grid grid-cols-2 xl:grid-cols-8 gap-5 mt-4">
    <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Mühəndis")}</p>
    </div>
   <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Lahiyə Rəhbəri")}</p>
    </div>
     <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Civil Engineer")}</p>
    </div>
      <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] text-center rounded-[12px] flex justify-center items-center'>
<p>{t("Keyfiyyətə Nəzarət Mühəndisi")}</p>
    </div>
     <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Sahə Mühəndisi")}</p>
    </div>
     <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Planlama")}</p>
    </div>
     <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("İş İcracısı")}</p>
    </div>
    <div className='border border-[#2a3d63] bg-[#FFF8EA] h-[50px] text-[#1C1C1C] rounded-[12px] flex justify-center items-center'>
<p>{t("Supervisor")}</p>
    </div>
</ul>

        <p className='text-[18px] md:text-[24px] text-[#2a3d63] font-medium mt-[56px] md:mt-[72px]'>{t("Şəxsi Layihələr")}</p>
        {/* Kategoriler */} 
        <div className="flex mt-4 overflow-x-auto flex-nowrap scrollbar-hide">
          {categories.map(({ value, label }) => (
            <button
              key={value}
              className={`md:px-8 whitespace-nowrap px-6 py-3 md:text-[18px] ${
                filter === value
                  ? 'bg-[#2a3d63] text-white'
                  : 'border-b-[1px] border-[#2a3d63] text-[#1C1C1C]'
              }`}
              onClick={() => handleFilterChange(value)}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Filtrelenmiş Projeler */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mt-[42px]">
          {filteredItems.map((item) => (
         <a href={`/${currentLanguage}/leader-projects/${item?.id}`}>
            <div
  key={item.id}
  className="relative group w-full border border-[#E5E5E5] rounded-lg overflow-hidden"
>
    {/* IMAGE */}
                <img
  src={`https://cortex-site.runasp.net/${item.images?.[0]}`}
  className="w-full object-cover h-[220px]"
  alt=""
/>
  {/* OVERLAY CONTENT */}
  <div className="
    absolute inset-0
    bg-black/50
    opacity-0
    group-hover:opacity-100
    transition-opacity duration-300
    flex flex-col justify-end
    p-4
  ">
    {/* TOP */}
    <div >
      <p className="text-white text-[18px] md:text-[18px] font-medium">
        {getLocalizedField(item, 'title')}
      </p>
       <p className="text-white text-[18px] md:text-[14px] font-medium">
        {getLocalizedField(item, "description")?.replace(/<[^>]*>/g, '').slice(0, 80)}...
      </p>

    </div>

  </div>
</div>
         </a>

          ))}
        </div>
      </div> 
    </div>
  );
};

export default LeaderItems;

  